import {
  PRODUCT_COMPARER_ACTIVE_INDEX,
  PRODUCT_COMPARER_DIRECT_COMPARISON_PRODUCT_CHANGE,
  PRODUCT_COMPARER_DIRECT_COMPARISON_TOGGLE,
} from '../action-types';

// @ts-expect-error - Automatic, Please fix when editing this file
const reviewDirectComparisonProductIds = (comparerProducts, productType) => ({
  comparerProducts,
  productType,
  type: PRODUCT_COMPARER_DIRECT_COMPARISON_PRODUCT_CHANGE,
});

// @ts-expect-error - Automatic, Please fix when editing this file
const storeActiveIndex = (activeIndex, productComparisonId) => ({
  activeIndex,
  productComparisonId,
  type: PRODUCT_COMPARER_ACTIVE_INDEX,
});

// @ts-expect-error - Automatic, Please fix when editing this file
const toggleDirectComparisonProductId = (productId, productType) => ({
  productId,
  productType,
  type: PRODUCT_COMPARER_DIRECT_COMPARISON_TOGGLE,
});

export default {
  reviewDirectComparisonProductIds,
  storeActiveIndex,
  toggleDirectComparisonProductId,
};
